(function () {
  // Trova un nodo che contiene un certo testo (comodo per EXPO)
  function findNodeByText(root, text) {
    const walker = document.createTreeWalker(root || document, NodeFilter.SHOW_ELEMENT, null);
    const q = (text || '').toLowerCase();
    let node;
    while ((node = walker.nextNode())) {
      const t = (node.textContent || '').trim().toLowerCase();
      if (t.includes(q)) return node;
    }
    return null;
  }

  function mount() {
    // 1) Prendi l’"opener" del popup del tema Dawn
    const openerBtn =
      document.querySelector('modal-opener.product-popup-modal__opener button') ||
      document.querySelector('button.product-popup-modal__button') ||
      document.querySelector('.product-popup-modal__link, [data-modal]');

    if (!openerBtn) return false;

    // 2) Trova la label/caption dell'opzione EXPO "Seleziona la tua misura"
    const scope = document.querySelector('main') || document;
    const labelNode =
      findNodeByText(scope, 'seleziona la tua misura') ||
      findNodeByText(scope, 'scegli la tua misura') ||
      findNodeByText(scope, 'seleziona la misura') ||
      document.querySelector('label[for*="size"], [aria-label*="misura" i]');

    if (!labelNode) return false;

    // Evita doppioni
    if (document.querySelector('.size-guide-inline')) return true;

    // 3) Crea un link inline che clicca il bottone originale
    const span = document.createElement('span');
    span.className = 'size-guide-inline';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'size-guide-inline-link';
    btn.textContent = 'Guida alle taglie';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openerBtn.click(); // apre il popup del tema
    });

    span.appendChild(btn);
    labelNode.insertAdjacentElement('afterend', span);

    return true;
  }

  // Tenta subito + ritenta per 5s (EXPO carica dopo)
  if (!mount()) {
    const start = Date.now();
    const iv = setInterval(function () {
      if (mount() || Date.now() - start > 5000) clearInterval(iv);
    }, 250);
  }

  // Osserva cambi DOM (EXPO rinfresca quando cambi varianti)
  const mo = new MutationObserver(() => mount());
  mo.observe(document.body, { childList: true, subtree: true });
})();

